import type { PortalNotification } from './notificationHref';

export function isDiscountDecision(notification: PortalNotification): boolean {
  return notification.type === 'motor_further_discount_accepted' || notification.type === 'motor_further_discount_rejected';
}

/** Offline recovery belongs in the bell, even when login restores the quote page. */
export function showDiscountPopup(notification: PortalNotification, source: string, pathname: string, search: string): boolean {
  if (!isDiscountDecision(notification) || source !== 'live') return false;
  if (pathname.replace(/\/$/, '') !== '/dashboard/products/motor/quote') return false;
  const quotation = new URLSearchParams(search).get('quotationNo');
  return !!quotation && (quotation === notification.quotation_no || quotation === notification.metadata?.source_quotation_no);
}
